import { tv } from 'tailwind-variants'

import { StatusBadge, statusBadgeVariants } from '@/components/ui'
import { DOCUMENT_STATUSES } from '@/modules/documents/constants'
import {
  PROJECT_ANIMATED_STATUSES,
  PROJECT_STATUS_SLOTS,
} from '@/modules/projects/components/ProjectStatusBadge'
import { humanizeText } from '@/utils'

const documentStatusBadgeVariants = tv({
  extend: statusBadgeVariants,
  variants: {
    status: {
      ...PROJECT_STATUS_SLOTS,
      [DOCUMENT_STATUSES.recognizing]: {
        base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
        dot: 'bg-blue-500',
        icon: 'text-blue-500',
      },
      [DOCUMENT_STATUSES.indexing]: {
        base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
        dot: 'bg-blue-500',
        icon: 'text-blue-500',
      },
      [DOCUMENT_STATUSES.enqueued]: {
        base: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100',
        dot: 'bg-amber-500',
        icon: 'text-amber-500',
      },
    },
  },
})

const DOCUMENT_ANIMATED_STATUSES: string[] = [
  ...PROJECT_ANIMATED_STATUSES,
  DOCUMENT_STATUSES.recognizing,
  DOCUMENT_STATUSES.indexing,
]

interface DocumentStatusBadgeProps {
  status?: string
  className?: string
  showLabel?: boolean
}

export const DocumentStatusBadge = ({
  status,
  className,
  showLabel,
}: DocumentStatusBadgeProps) => {
  return (
    <StatusBadge
      slots={documentStatusBadgeVariants({ status })}
      label={humanizeText(status ?? '')}
      animated={!!status && DOCUMENT_ANIMATED_STATUSES.includes(status)}
      className={className}
      showLabel={showLabel}
    />
  )
}
